const foodIcons = {
  Entrada: "restaurant",
  "Desayuno / Merienda": "emoji_food_beverage",
  "Plato principal": "lunch_dining",
  Postre: "icecream",
  Ensaladas: "rice_bowl",
  "Bebidas sin alcohol": "water_drop_outlined",
  "Bebidas con alcohol": "local_bar",
};

export const getFoodIcon = (categoria) => {
  return foodIcons[categoria] || "restaurant";
};

export const allFoodIcons = [
  "restaurant",
  "emoji_food_beverage",
  "lunch_dining",
  "icecream",
  "rice_bowl",
  "water_drop_outlined",
  "local_bar",
  "fastfood",
  "food_bank",
  "dinner_dining",
  "kitchen",
  "cake",
  "egg",
  "egg_alt",
  "set_meal",
  "soup_kitchen",
  "takeout_dining",
  "brunch_dining",
  "liquor",
  "local_cafe",
  "no_drinks",
  "ramen_dining",
  "bakery_dining",
  "local_pizza",
];
